<template>
  <v-file-input :label="label" :value="value" :dense="true" :placeholder="info" v-on:change="loadTextFromFile"></v-file-input>
</template>

<script>
export default {
  name: "fileReader",
  computed: {
    info () {
      return this.$t('info')
    }
  },
  data() {
    return {
      value: undefined,
    }
  },
  props: {
    clearValue: false,
    label: undefined,
  },
  methods: {
    loadTextFromFile (file) {
      if (file) {
        console.log(file)
        const reader = new FileReader();
        reader.onerror = (event) => {
          alert(event.target.error.name);
        };
        reader.onload = e => this.$emit("load", e.target.result)
        reader.readAsText(file);
      } else {
        this.$emit("clear")
      }
    },
  },
  watch: {
    clearValue: function(newVal, oldVal) {
      this.value = null
    }
  },
  i18n: {
    messages: {
      de: {
        info: 'Bitte Datei auswählen...'
      },
      en: {
        info: 'Select opticheck file...'
      },
    },
  },
}
</script>
